var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyEvolusLogoGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 36,
    viewBox: "0 0 49 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8031 35.9343L32.588 35.8183C26.7141 35.7719 24.3341 30.3521 24.3772 24.9887L24.4236 21.0772C24.5296 8.09961 35.1139 0.157258 48.0915 0.260018L47.9457 18.0541C47.9092 22.6849 44.1237 26.4108 39.4895 26.371L37.4012 26.3544V26.908L39.4431 26.9246C48.1479 26.9942 47.8429 30.7665 47.8031 35.4238V35.9343Z",
    fill: "#E5554F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.379942 35.4239C0.343479 30.7699 0.0351992 26.9976 8.73996 26.9247L10.7852 26.9081V26.3545L8.69355 26.3711C4.06272 26.4075 0.277184 22.685 0.237406 18.0541L0.0915527 0.260082C13.0691 0.154007 23.6534 8.09968 23.7595 21.0773L23.8059 24.9888C23.849 30.3522 21.4723 35.772 15.595 35.8184L0.379942 35.9344V35.4239Z",
    fill: "#E5554F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEvolusLogoGraphic);
export default __webpack_public_path__ + "static/media/my-evolus-logo-graphic.bd7a62bdfc9c3c916292bcac4b0ce554.svg";
export { ForwardRef as ReactComponent };